import React from 'react'
// import classes from "./Landing.module.css";

const Landing = () => {
   return <div className='container'>Landing Page</div>
}

export default Landing
